import './HeaderMobileNav.scss'

import { NavItem } from '@config/nav'
import {
    EuiFlyout,
    EuiFlyoutBody,
    EuiHeaderLink,
    EuiIcon,
    EuiPortal,
    EuiSideNav,
    EuiSideNavItemType,
} from '@elastic/eui'
import { buildHref, isNavActive } from '@utils/nav'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const HeaderMobileNav = ({ items }: { items: NavItem[] }) => {
    const [isOpen, setIsOpen] = useState(false)
    const { t } = useTranslation(['navigation'])
    const navigate = useNavigate()

    const handleOnClick = (item: NavItem) => {
        if (item.href) {
            navigate(item.href)
        }

        setIsOpen(false)
    }

    const navItems: EuiSideNavItemType<any>[] = items.map((item) => ({
        id: item.id,
        name: t(item.name),
        onClick: () => handleOnClick(item),
        isSelected: isNavActive(item),
        icon: item.icon ? <EuiIcon type={item.icon} /> : undefined,
        items: item.items?.map((sub) => ({
            id: sub.id,
            name: t(sub.name),
            isSelected: isNavActive(sub),
            onClick: () => handleOnClick(sub),
        })),
    }))

    return (
        <>
            {isOpen && (
                <EuiFlyout
                    onClose={() => setIsOpen(false)}
                    side="left"
                    ownFocus
                >
                    <EuiFlyoutBody>
                        <EuiSideNav
                            className="mobile-nav"
                            isOpenOnMobile
                            heading={null}
                            mobileTitle={null}
                            mobileBreakpoints={undefined}
                            items={navItems}
                        />
                    </EuiFlyoutBody>
                </EuiFlyout>
            )}
            <EuiHeaderLink size="m" onClick={() => setIsOpen((prev) => !prev)}>
                <EuiIcon type="grabOmnidirectional" color="white" size="l" />
            </EuiHeaderLink>
        </>
    )
}

export default HeaderMobileNav
